import React from 'react';

interface CheckYourInboxProps {
	email: string
}

const CheckYourInboxPage = (props: CheckYourInboxProps) => {
	const {
		email,
	} = props;

	return (
		<div className="body-content registration-info-page">
			<div className="registration registration-success">
				<span className="icon icon-only icon-mail" />
				<h4>Check your inbox!</h4>
				<p>
					A verification link has been sent to {email}.
				</p>
				<p>
					If you have not received this, check your spam inbox.
				</p>
			</div>
		</div>
	);
};

export default CheckYourInboxPage;
